import { getSiteConfig } from '../../siteConfig';

export const useHideOnSite = (hiddenLanguages) => {
  const storyblokLanguage = getSiteConfig().storyblokLanguage;

  if (hiddenLanguages) {
    return hiddenLanguages.includes(storyblokLanguage);
  } else return false;
};

export default useHideOnSite;
